import { render, staticRenderFns } from "./CF.vue?vue&type=template&id=4e3a67cf&scoped=true&"
import script from "./CF.vue?vue&type=script&lang=js&"
export * from "./CF.vue?vue&type=script&lang=js&"
import style0 from "./CF.vue?vue&type=style&index=0&id=4e3a67cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3a67cf",
  null
  
)

export default component.exports